import HeaderWithCopyComponent from './ProductBuilder/HeaderWithCopy';
import GalleryComponent from './ProductBuilder/Gallery';
import FeaturesComponent from './ProductBuilder/Features';
import ProductColoursComponent from './ProductBuilder/ProductColours';
import ProductModelsComponent from './ProductBuilder/ProductModels';
import SpecificationsComponent from './ProductBuilder/Specifications';
import SpecificationsTable from './ProductBuilder/SpecsTable';
import CallToActionTool from "./ProductBuilder/ShoppingTools/CallToActionTool";
import IFrame from './GeneralPageBuilder/IFrame';
import VirtualTour from './GeneralPageBuilder/VirtualTour';
import SliderControls from "./GeneralPageBuilder/SliderControls";

const ProductBuilder = props => {
	const { data, category, slug, builder } = props;

	return builder.map((block, i) => {
		switch (block.component) {
			case "headerWithCopy":
				return <HeaderWithCopyComponent category={category} slug={slug} block={block} key={block.component + i} />;
			case "gallery":
				return <GalleryComponent category={category} slug={slug} block={block} key={block.component + i} />;
			case "features":
				return <FeaturesComponent category={category} slug={slug} block={block} key={block.component + i} />;
			case "productColours":
				return <ProductColoursComponent category={category} slug={slug} block={block} key={block.component + i} />;
			case "productModels":
				return <ProductModelsComponent category={category} slug={slug} block={block} key={block.component + i} />;
			case "callToActions":
				return (
					<CallToActionTool
						pageData={data}
						category={category}
						slug={slug}
						block={block}
						setOpenBATD={props.setOpenBATD}
						getFormData={props.getFormData}
						key={block.component + i}
					/>
				);
			case "specifications":
				return <SpecificationsComponent category={category} slug={slug} block={block} key={block.component + i} />;
			case "vertexSlider":
				return <SliderControls category={category} slug={slug} block={block} key={block.component + i} />
			case "iframe":
				return <IFrame category={category} slug={slug} block={block} key={block.component + i} />;
			case "virtualTour":
				return <VirtualTour category={category} slug={slug} block={block} key={block.component + i} />;
			case "specificationsTable":
				return <SpecificationsTable category={category} slug={slug} block={block} key={block.component + i} />;
		}
	});
};

export default ProductBuilder;